import {Navigate, Outlet} from 'react-router-dom';

import {PHASE} from '@zzng/common/constants/phase';
import {isRequiredKakaoTalkVersionForHome} from '@zzng/common/scheme/digitalcard';
import {isKakaoTalk} from '@zzng/common/utils/agent';

import {SHARED_ROUTES} from '@/shared/constants/routes';

const InAppGuardOutlet = () => {
  if (TARGET === PHASE.LOCAL) {
    return <Outlet />;
  }

  if (!isKakaoTalk) {
    const redirectUrl = encodeURIComponent(location.href);
    window.location.href = `${location.origin}?redirectUrl=${redirectUrl}`;
    return <></>;
  }

  if (window.digitalCard?.isSubDevice?.()) {
    return <Navigate to={SHARED_ROUTES.INVALID_DEVICE} replace />;
  }

  if (!isRequiredKakaoTalkVersionForHome) {
    return <Navigate to={SHARED_ROUTES.INVALID_VERSION} replace />;
  }

  return <Outlet />;
};

export default InAppGuardOutlet;
